import Image from 'next/image';
import appconfig from '@/utils/appConfig';
import { Button, LoadingSpinner } from '@/components';
import Link from 'next/link';
import { useState } from 'react';
import VehicleSpecifications from '../VehicleDetail/VehicleSpecifications';
import clsx from 'clsx';
import { SharedVehicle } from '@/types/types';

interface VehicleChooserProps {
    title: string | null;
    vehicleImage: string | null;
    alt: string | null;
    slug: string | null;
    vehicleId: string;
    vehicleSpecifications: SharedVehicle['vehicleSpecifications'];
    vehicleHireProps: SharedVehicle['vehicleHireProps'];
}

const VehicleChooser = ({
    title,
    vehicleImage,
    alt,
    slug,
    vehicleId,
    vehicleSpecifications,
    vehicleHireProps,
}: VehicleChooserProps) => {
    const [isLoading, setIsLoading] = useState(false);

    const carLinkProps = {
        pathname: `/${slug}`,
        // query: { vehicleId: vehicleId },
    };

    const carQuoteProps = {
        pathname: `/quote`,
        query: { vehicleId: vehicleId },
    };

    const containerClasses = clsx('p-2');

    const innerContainerClasses = clsx(
        `bg-white`,
        `rounded-md`,
        `shadow-[0_2px_8px_rgba(0,0,0,.16)]`,
        `border-l-8`,
        `${appconfig.colors.coloredSectionBorder}`,
        `py-2`
    );

    const titleClasses = clsx(
        'bg-gray-200',
        'p-2',
        'm-2',
        'flex',
        'justify-center',
        'h-16',
        'items-center',
        'text-balance',
        'text-center'
    );

    const vehicleClasses = clsx(
        'p-4',
        'border-b',
        'border-b-gray-300',
        'mb-4',
        'h-[280px]',
        'items-center',
        'flex',
        'flex-wrap',
        'justify-center'
    );

    const pricingClasses = clsx(
        'py-2',
        'border-b',
        'border-t',
        'border-gray-300',
        'mb-2',
        'flex',
        'justify-around',
        'items-center'
    );

    return (
        <div className={containerClasses}>
            <div className={innerContainerClasses}>
                <div className={titleClasses}>
                    <Link
                        href={carLinkProps}
                        onClick={() => {
                            setIsLoading(true);
                        }}
                    >
                        {title}
                    </Link>
                </div>
                <div className="px-4">
                    <Link
                        href={carLinkProps}
                        onClick={() => {
                            setIsLoading(true);
                        }}
                        title="Click to see more details about this vehicle"
                    >
                        <div className={vehicleClasses}>
                            {isLoading ? (
                                <LoadingSpinner />
                            ) : (
                                <Image
                                    unoptimized={true}
                                    src={vehicleImage as string}
                                    alt={alt || (title as string)}
                                    width={384}
                                    height={217}
                                />
                            )}
                        </div>
                        <VehicleSpecifications
                            vehicleSpecifications={vehicleSpecifications}
                            className="mb-2"
                        />
                        <div className={pricingClasses}>
                            <div className="text-2xl font-bold">
                                £{vehicleHireProps?.pricePerDay}/day
                            </div>
                            <div className="text-2xl font-bold">
                                £{vehicleHireProps?.pricePerWeek}/week
                            </div>
                        </div>
                    </Link>
                    <div className="mb-2 flex justify-center">
                        <Link
                            href={carQuoteProps}
                            onClick={() => {
                                setIsLoading(true);
                            }}
                            className="mt-2"
                        >
                            <Button label="Quote / Request booking" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VehicleChooser;
